import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const BoxIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M19.92 16.54L12 21.1L4.08 16.54V7.4L12 2.82L19.92 7.4V16.54ZM6.36 7.84L8.5 9.06L14.06 5.86L11.92 4.64L6.36 7.84ZM9.96 9.9L12 11.1L17.58 7.88L15.56 6.66L9.96 9.9ZM5.58 15.56L11.22 18.86V12.46L5.58 9.16V15.56ZM12.8 12.46V18.84L18.22 15.68V9.3L12.8 12.46Z" />
    </SvgIcon>
  );
});
